export const webPortfolio = [
  {
    id: 1,
    title: 'Math Magicians App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/math-magicians',
    liveUrl: 'https://hamzaoutdoors-math-magicians.herokuapp.com/',
    img: 'assets/projects/math_magician.png',
  },
  {
    id: 2,
    title: 'Coffee Shop App',
    sourceUrl:
    'https://github.com/Hamzaoutdoors/CoffeeJunkie',
    liveUrl: 'https://hamzaoutdoors-coffeejunkie.netlify.app/',
    img: 'assets/projects/coffee_shop.png',
  },
  {
    id: 3,
    title: 'Rental Cars App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/rentalcars_frontend',
    liveUrl: 'https://hanjelscars.netlify.app/',
    img: 'assets/projects/rent_car.png',
  },
  {
    id: 4,
    title: 'Space Travelers Hub',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Space-Travelers-Hub',
    liveUrl: 'https://space-traveler-hub-hl.netlify.app/',
    img: 'assets/projects/space.png',
  },
  {
    id: 5,
    title: 'Code & Outdoors website',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Code_Outdoors_Meetings',
    liveUrl: 'https://hamzaoutdoors.github.io/Code_Outdoors_Meetings/',
    img: 'assets/projects/code_outdoors.png',
  },
  {
    id: 6,
    title: 'Series lovers App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Serie_Lovers---JS-Capstone-',
    liveUrl: 'https://hamzaoutdoors.github.io/Serie_Lovers---JS-Capstone-/',
    img: 'assets/projects/series.png',
  },
];

export const mobilePortfolio = [
  {
    id: 1,
    title: 'Yalatsara trip booking',
    sourceUrl: 'https://www.figma.com/file/vZ5uF8m5EOVyHSxHGN3MiN/Design-kits?node-id=1%3A67&t=GLXm1wAg6EuWcx7c-1',
    liveUrl: 'https://www.figma.com/file/vZ5uF8m5EOVyHSxHGN3MiN/Design-kits?node-id=1%3A67&t=GLXm1wAg6EuWcx7c-1',
    img:
        'assets/projects/yalatsara.png',
  },
  {
    id: 2,
    title: 'E-Wallet App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/E_Wallet_app',
    liveUrl: 'https://e-wallet-app1.herokuapp.com/',
    img:
        'assets/projects/e_wallet.png',
  },
  {
    id: 3,
    title: 'Rental Cars App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/rentalcars_frontend',
    liveUrl: 'https://hanjelscars.netlify.app/',
    img: 'assets/projects/rent_mobile.png',
  },
  {
    id: 4,
    title: 'My Blog App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Blog_app',
    liveUrl: 'https://hanjelscars.netlify.app/',
    img:
        'assets/projects/blog.png',
  },
  {
    id: 5,
    title: 'R3 LOGISTICS',
    sourceUrl: 'https://github.com/Hamzaoutdoors/R3_front',
    liveUrl: 'https://www.figma.com/file/tUtlSufwewx5IlsG7exQye/R3-Logistic-%231?node-id=328%3A3156&t=plkTWmZ7nCpuzRXl-0',
    img:
        'assets/projects/r3.png',
  },
  {
    id: 6,
    title: 'NeoKraal Market Place',
    sourceUrl: 'https://github.com/Hamzaoutdoors/NeokraalV2',
    liveUrl: 'https://play.google.com/store/apps/details?id=com.neo_front',
    img:
        'assets/projects/neo.png',
  },
];

export const credentials = [
  {
    id: 1,
    title: 'HTML5/CSS3',
    credentialUrl: 'https://www.credential.net/b55b54c2-3ba8-4264-8ee6-625dcd529878',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/htmlcss-cred.png',
  },
  {
    id: 2,
    title: 'JavaScript ES6',
    credentialUrl: 'https://www.credential.net/792d39b5-29ed-473c-830e-0193daf24663',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/js-cred.png',
  },
  {
    id: 3,
    title: 'ReactJS & Redux',
    credentialUrl: 'https://www.credential.net/87916e61-5e83-415e-96c1-d6031bd770ad',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/react-cred.png',
  },
  {
    id: 4,
    title: 'Ruby & DataBases',
    credentialUrl: 'https://www.credential.net/8d1d6c34-7e24-4ed3-8c63-05e4b4080f26',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/ruby-cred.png',
  },
  {
    id: 5,
    title: 'Ruby on Rails',
    credentialUrl: 'https://www.credential.net/07054f1d-c771-42d6-b053-33b0604f69b0',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/ror-cred.png',
  },
  {
    id: 6,
    title: 'Full Stack Diploma',
    credentialUrl: 'https://www.credential.net/4e05c71f-9679-4c8c-b14b-6eef7ac68be4',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/diplomat.png',
    badgeImg:
        './assets/certificates/badge.png',
    fullStack: true,
  },
];
